module.exports = __webpack_public_path__ + "24e0b8822fbaa077e553416f6c463cfe.png";